<template>
    <div class="m-toolbar">
        <slot></slot>
    </div>
</template>

<script>
/* eslint-disable */
/**
 * m-toolbar —— 手机端顶部按钮条
 * 把页面原有的一排操作按钮包起来，窄屏下横向滚动，不换行、不撑破布局。
 */
export default {
    name: 'MToolbar',
};
</script>
